import { crmAPI } from '../crm/context/CRMAuthContext';

export const inStaffManager = () => window.location.pathname.startsWith('/admin/manager');

const relativePath = url => {
  if (url.startsWith('http')) return new URL(url).pathname.replace(/^\/api/, '') + new URL(url).search;
  return url.replace(/^\/api(?=\/)/, '');
};

// Scoped transport for existing Manager screens. Never copy staff cookies into
// legacy JWT/localStorage or silently fall back to legacy/global APIs.
export const routeStaffManagerRequest = config => {
  if (!inStaffManager()) return config;
  config.adapter = async request => crmAPI.request({
    url: `/manager${relativePath(request.url)}`,
    method: request.method,
    params: request.params,
    data: request.data,
    signal: request.signal,
    headers: { 'Content-Type': 'application/json' },
  });
  config._staffWorkspace = true;
  return config;
};

export const managerFetch = async (url, options = {}) => {
  if (!inStaffManager()) return fetch(url, options);
  try {
    const response = await crmAPI.request({ url: `/manager${relativePath(url)}`, method: options.method || 'GET', data: options.body, headers: { 'Content-Type': 'application/json' }, signal: options.signal });
    return new Response(JSON.stringify(response.data), { status: response.status, headers: { 'Content-Type': 'application/json' } });
  } catch (error) {
    if (!error.response) throw error;
    return new Response(JSON.stringify(error.response.data), { status: error.response.status, headers: { 'Content-Type': 'application/json' } });
  }
};